import PageContent from "../ncl/NclPlainPageContent/PlainPageContent";
import './PageContent.scss';

export default PageContent;
